import config from '../../../config/config';
import getRequest from '../base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  fetchCommercialTransactionList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.emsp.transactionApiUrl}api/emsp/v1/cdrs`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination version 2
   * @param {any} query - The query
   */
  fetchPersonalTransactionList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.emsp.sessionsApiUrl}api/emsp/v1/personal-charging-transaction`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchCommercialTransactionListFilters: () => {
    return getRequest(`${config.emsp.transactionApiUrl}api/emsp/v1/cdrs/list-filters`);
  },
  /**
   * Fetch maintenance schedule API for export
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the exported data
   */
  fetchCommercialTransactionExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.emsp.transactionApiUrl}api/emsp/v1/cdrs/export`, {
      ...parameters,
    });
  },
};
